import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import Vision from './Components/Vision.js'
import Blog from './Components/Blog.js';
import {Route,BrowserRouter} from 'react-router-dom'
import {CookiesProvider} from 'react-cookie'
import BlogDetails from './Components/BlogDetails.js';

import 'bootstrap/dist/css/bootstrap.css';

function Router(){
  return (
    
      <CookiesProvider>
        <BrowserRouter>
        <Route exact path="/vision/" component={Vision}/>
        <Route exact path="/blog/" component={Blog}/>
        <Route exact path="/" component={App}/>
        <Route path="/blog/:id" component={BlogDetails} />
        </BrowserRouter>
      </CookiesProvider>
    
  )
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <Router/>
   
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
